import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../service';

import { Logger } from '../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McPrmService {
  constructor(
    private sdk: MycureSDK,
  ) {

  }


  /**
   * 
   * @param orgId 
   * @param message 
   * @param recipients 
   * @param groups 
   * @param provider - 'txtconnect5' by default
   */
  async sendSmsMessage(orgId: string, message: string, recipients: string[], groups: string[], provider: string = 'txtconnect5') {
    const org = await this.sdk.organizations().get(orgId);
    log.debug('values', orgId, message, recipients, groups, provider);

    if (!org.sms_configs || (org.sms_configs && org.sms_configs.length == 0)) {
      throw new Error('missing config');
    }

    let recipientNos: string[] = recipients || [];
    // if sending px from px group
    if (groups && groups.length != 0) {
      const pxQuery: any = { facility: orgId, tags: { $in: groups } };
      const res = await this.sdk.personalDetails().find(pxQuery);
      const patients: any[] = res.items;

      // get px mobile no, and add it 
      patients.map((px: any) => {
        if (px && px.mobileNo) {
          // if not yet existing
          if (!recipientNos.includes(px.mobileNo)) {
            recipientNos.push(px.mobileNo);
          }
        }
      });
    }
    
    // require recipient nos
    if (recipientNos.length == 0) {
      throw new Error('missing recipient');
    }

    log.debug('using recipients', recipientNos);

    // compose message
    const messageBody: any = {
      organization: orgId, 
      provider, message,
      recipientType: 'mf-patient',
      recipients: recipientNos
    };

    return this.sdk.sms().create(messageBody);
  }
}
